import React from "react";
import { Typography } from "@mui/material";

const SectionTitle = ({ title, fontSize = "32px", color = "#12538B", fontWeight = 700, lineHeight = "39.08px", mb = 2, dataAos ,sx = {},  }) => {
  return (
    <Typography
      sx={{
        fontSize: fontSize,
        color: color,
        fontWeight: fontWeight,
        mb: mb,
        lineHeight: lineHeight,
        ...sx, 
      }}
      data-aos={dataAos}
      // {...(dataAos && { "data-aos": dataAos })}
    >
      {title}
    </Typography>
  );
};

export default SectionTitle;
